webpackJsonp([20],{

/***/ 1317:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1602)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1348),
  /* template */
  __webpack_require__(1763),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6f6d48d4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1348:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(12);

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _isEmpty = __webpack_require__(23);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _utilities = __webpack_require__(51);

var _icon_facebook = __webpack_require__(232);

var _icon_facebook2 = _interopRequireDefault(_icon_facebook);

var _icon_messenger = __webpack_require__(389);

var _icon_messenger2 = _interopRequireDefault(_icon_messenger);

var _icon_twitter = __webpack_require__(233);

var _icon_twitter2 = _interopRequireDefault(_icon_twitter);

var _icon_whatsapp = __webpack_require__(392);

var _icon_whatsapp2 = _interopRequireDefault(_icon_whatsapp);

var _icon_email = __webpack_require__(347);

var _icon_email2 = _interopRequireDefault(_icon_email);

var _icon_share = __webpack_require__(391);

var _icon_share2 = _interopRequireDefault(_icon_share);

var _icon_pinterest = __webpack_require__(390);

var _icon_pinterest2 = _interopRequireDefault(_icon_pinterest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'amp-share-pane',
  props: {
    node: {
      type: Object,
      default: {}
    },
    mode: {
      type: String,
      default: ''
    },
    quote: {
      type: String,
      default: ''
    }
  },
  methods: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['requestDomain'])),
  computed: {
    enableLinks: function enableLinks() {
      return (0, _get2.default)(this.$store.state, 'settings.share', false);
    },
    title: function title() {
      return (0, _utilities.updateTitleByNodeType)({ type: (0, _get2.default)(this, 'node.type', ''), originalTitle: (0, _get2.default)(this.node, 'title', '') });
    },
    shareTitle: function shareTitle() {
      if (this.quote) return this.quote;
      return this.title;
    },
    twitterUrl: function twitterUrl() {
      return this.shareUrl + '&related=&via=AbacusNews';
    },
    facabookMessengerUrl: function facabookMessengerUrl() {
      return 'fb-messenger://share/?link=' + this.shareUrl + '&app_id=' + this.facebookAppID;
    },
    emailUrl: function emailUrl() {
      return 'mailto:?subject=Abacus: ' + this.shareTitle + '&body=' + (this.subheading || this.shareTitle) + '%0D%0A' + this.shareUrl;
    },
    facebookUrl: function facebookUrl() {
      if (this.mode === 'blockquote') {
        var quote = !(0, _isEmpty2.default)(this.shareTitle) ? '&quote=' + this.shareTitle : '';
        return this.shareUrl + '&src=sdkpreparse' + quote;
      }
      return this.shareUrl + '&src=sdkpreparse';
    },
    facebookAppID: function facebookAppID() {
      return (0, _get2.default)(this.$store.state, 'settings.FB_APP_ID', '');
    },
    nodeUrl: function nodeUrl() {
      return (0, _get2.default)(this.node, 'relative_url', '');
    },
    shareUrl: function shareUrl() {
      return '' + this.requestDomain() + this.nodeUrl;
    }
  },
  components: {
    SvgFacebookIcon: _icon_facebook2.default,
    SvgFacebookMessengerIcon: _icon_messenger2.default,
    SvgWhatsappIcon: _icon_whatsapp2.default,
    SvgTwitterIcon: _icon_twitter2.default,
    SvgEmailIcon: _icon_email2.default,
    SvgShareIcon: _icon_share2.default,
    SvgPinterestIcon: _icon_pinterest2.default
  }
};

/***/ }),

/***/ 1513:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".sharePane[data-v-6f6d48d4]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;max-width:20rem;margin-top:1.75rem;margin-left:.3125rem;cursor:not-allowed}.sharePane.enable[data-v-6f6d48d4]{cursor:pointer}.sharePane.blockquote[data-v-6f6d48d4]{margin-top:0;margin-left:.9375rem;max-width:4.6875rem;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.sharePane.blockquote amp-social-share[data-v-6f6d48d4]{width:.625rem}.sharePane.blockquote amp-social-share[type=email][data-v-6f6d48d4],.sharePane.blockquote amp-social-share[type=facebookmessenger][data-v-6f6d48d4],.sharePane.blockquote amp-social-share[type=whatsapp][data-v-6f6d48d4]{display:none}.sharePane amp-social-share[data-v-6f6d48d4]{background-image:none;background-color:transparent;text-align:center;width:2.6875rem}.sharePane a[data-v-6f6d48d4],.sharePane amp-social-share[data-v-6f6d48d4]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;outline:none}.sharePane a[data-v-6f6d48d4]{width:3.75rem;height:2.75rem}.sharePane .icon--facebook[data-v-6f6d48d4]{width:.6875rem;height:1.4375rem}.sharePane .icon--twitter[data-v-6f6d48d4]{margin-top:.125rem;width:1.375rem;height:1.125rem}.sharePane .icon--whatsapp[data-v-6f6d48d4]{width:1.3125rem;height:1.3125rem}.sharePane .icon--facebook-messenger[data-v-6f6d48d4]{width:1.25rem;height:1.25rem}.sharePane .icon--email[data-v-6f6d48d4]{width:1.25rem;height:.9375rem}.sharePane svg[data-v-6f6d48d4]{fill:#f8008e}", "", {"version":3,"sources":["/app/components/article/amp/AmpSharePane.vue"],"names":[],"mappings":"AAgCA,4BACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,gBAAiB,AACjB,mBAAoB,AACpB,qBAAuB,AACvB,kBAAoB,CACrB,AACD,mCACI,cAAgB,CACnB,AACD,uCACI,aAAc,AACd,qBAAuB,AACvB,oBAAqB,AACrB,uBAAwB,AACpB,oBAAqB,AACjB,0BAA4B,CACvC,AACD,wDACM,aAAgB,CACrB,AACD,2NACQ,YAAc,CACrB,AACD,6CACI,sBAAuB,AACvB,6BAA8B,AAC9B,kBAAmB,AAUnB,eAAiB,CAEpB,AACD,2EAZI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAEhC,YAAc,CAejB,AAbD,8BACI,cAAe,AACf,cAAgB,CAWnB,AACD,4CACI,eAAiB,AACjB,gBAAkB,CACrB,AACD,2CACI,mBAAqB,AACrB,eAAgB,AAChB,eAAiB,CACpB,AACD,4CACI,gBAAiB,AACjB,gBAAkB,CACrB,AACD,sDACI,cAAe,AACf,cAAgB,CACnB,AACD,yCACI,cAAe,AACf,eAAkB,CACrB,AACD,gCACI,YAAc,CACjB","file":"AmpSharePane.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.sharePane[data-v-6f6d48d4] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  max-width: 20rem;\n  margin-top: 1.75rem;\n  margin-left: 0.3125rem;\n  cursor: not-allowed;\n}\n.sharePane.enable[data-v-6f6d48d4] {\n    cursor: pointer;\n}\n.sharePane.blockquote[data-v-6f6d48d4] {\n    margin-top: 0;\n    margin-left: 0.9375rem;\n    max-width: 4.6875rem;\n    -webkit-box-pack: start;\n        -ms-flex-pack: start;\n            justify-content: flex-start;\n}\n.sharePane.blockquote amp-social-share[data-v-6f6d48d4] {\n      width: 0.625rem;\n}\n.sharePane.blockquote amp-social-share[type=\"whatsapp\"][data-v-6f6d48d4], .sharePane.blockquote amp-social-share[type=\"facebookmessenger\"][data-v-6f6d48d4], .sharePane.blockquote amp-social-share[type=\"email\"][data-v-6f6d48d4] {\n        display: none;\n}\n.sharePane amp-social-share[data-v-6f6d48d4] {\n    background-image: none;\n    background-color: transparent;\n    text-align: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    width: 2.6875rem;\n    outline: none;\n}\n.sharePane a[data-v-6f6d48d4] {\n    width: 3.75rem;\n    height: 2.75rem;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    outline: none;\n}\n.sharePane .icon--facebook[data-v-6f6d48d4] {\n    width: 0.6875rem;\n    height: 1.4375rem;\n}\n.sharePane .icon--twitter[data-v-6f6d48d4] {\n    margin-top: 0.125rem;\n    width: 1.375rem;\n    height: 1.125rem;\n}\n.sharePane .icon--whatsapp[data-v-6f6d48d4] {\n    width: 1.3125rem;\n    height: 1.3125rem;\n}\n.sharePane .icon--facebook-messenger[data-v-6f6d48d4] {\n    width: 1.25rem;\n    height: 1.25rem;\n}\n.sharePane .icon--email[data-v-6f6d48d4] {\n    width: 1.25rem;\n    height: 0.9375rem;\n}\n.sharePane svg[data-v-6f6d48d4] {\n    fill: #F8008E;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1602:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1513);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("273c89e4", content, true, {});

/***/ }),

/***/ 1763:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['sharePane', _vm.enableLinks, _vm.mode]
  }, [_c('amp-social-share', {
    staticClass: "facebook",
    attrs: {
      "type": "facebook",
      "data-param-url": _vm.facebookUrl,
      "data-param-app_id": _vm.facebookAppID
    }
  }, [_c('svg-facebook-icon', {
    staticClass: "icon--facebook"
  })], 1), _c('amp-social-share', {
    staticClass: "facebook",
    attrs: {
      "type": "twitter",
      "data-param-url": _vm.twitterUrl,
      "data-param-text": _vm.shareTitle
    }
  }, [_c('svg-twitter-icon', {
    staticClass: "icon--twitter"
  })], 1), _c('amp-social-share', {
    staticClass: "whatsapp",
    attrs: {
      "type": "whatsapp",
      "data-param-text": _vm.shareTitle
    }
  }, [_c('svg-whatsapp-icon', {
    staticClass: "icon--whatsapp"
  })], 1), _c('amp-social-share', {
    attrs: {
      "type": "facebookmessenger",
      "data-share-endpoint": _vm.facabookMessengerUrl
    }
  }, [_c('svg-facebook-messenger-icon', {
    staticClass: "icon--facebook-messenger"
  })], 1), _c('amp-social-share', {
    staticClass: "email",
    attrs: {
      "type": "email",
      "data-param-url": "emailUrl"
    }
  }, [_c('svg-email-icon', {
    staticClass: "icon--email"
  })], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// 20.0c63a633a71942edd2c1.js